import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/MemberAuthContext';
import { APP_VERSION } from '../version';

// Decentní patička na všech stránkách přihlášeného uživatele.
// Klik na verzi / „Novinky" otevře changelog.
export default function AppFooter() {
  const navigate = useNavigate();
  const { member } = useAuth();
  if (!member) return null;

  return (
    <div style={{ marginTop: 'auto' }}>
      <div style={{
        borderTop: '1px solid var(--border)',
        padding: '14px 16px',
        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
        fontSize: '0.8rem', color: 'var(--text-muted)',
      }}>
        <span>TEČČKa v{APP_VERSION}</span>
        <span>·</span>
        <button
          onClick={() => navigate('/changelog')}
          style={{
            background: 'transparent', border: 'none', padding: 0, cursor: 'pointer',
            fontFamily: 'inherit', fontSize: '0.8rem', fontWeight: 600, color: 'var(--blue)',
          }}
        >
          Novinky ↗
        </button>
      </div>
    </div>
  );
}
